import { cloneDeep } from 'lodash';

import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { PossibleAdminRole } from '../../../../../objects/user/admin-roles/types';
import { RolesSchema } from '../../../../../objects/user/roles/roles-schema';
import { PossibleRole } from '../../../../../objects/user/roles/types';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsRequest } from '../../generic/communications-request/communications-request';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

import { CommunicationsRequestGetConversationLogPIIConstructor } from './communications-request-get-conversation-log-pii-constructor';
import { CommunicationsRequestGetConversationLogPIISchema } from './communications-request-get-conversation-log-pii-schema';

export class CommunicationsRequestGetConversationLogPII extends CommunicationsRequest {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected conversationLogId!: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationsRequestGetConversationLogPIIConstructor) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-param-reassign
    (parameters as any)[CommunicationsRequestSchema.type] = CommunicationsRequestName.getConversationLogPII;
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): CommunicationsRequestGetConversationLogPII {
    return new CommunicationsRequestGetConversationLogPII(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationsRequestGetConversationLogPII.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsRequestGetConversationLogPIISchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Roles
  /////////////////////////////////////////////////////////////////////////////

  // eslint-disable-next-line class-methods-use-this
  public getRequiredRoles(): PossibleRole[] {
    return [RolesSchema.Roles.getPII];
  }

  // eslint-disable-next-line class-methods-use-this
  public getRequiredAdminRoles(): PossibleAdminRole[] | undefined {
    return undefined;
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getConversationLogId(): string {
    return cloneDeep(this.conversationLogId);
  }
}
